export const increment = (integer: number) => {
  return integer + 1;
};
